module.exports = __webpack_public_path__ + "img/modular_settlement_complete@2x.79366a2e.png";